import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order } from 'models/order';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CartService } from '../cart/cart.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { RestApiService } from '../rest-api/rest-api.service';
import { UrlService } from '../url/url.service';
import { environment as env } from '../../../../../src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OrderService {
    private _$order: BehaviorSubject<any> = new BehaviorSubject([]);
    public portalId: string;
    public failingCourseList = [];
    public directBookingList = [];
    public onlineRequestList = [];


    constructor(
        private http: HttpClient,
        public _restApi: RestApiService,
        private _urlService: UrlService,
        private _cartService: CartService,
        private config: ConfigurationService,
        private _restApiService: RestApiService
    ) {}

    public get order$(): Observable<Order> {
        return this._$order.asObservable();
    }

    updateOrder(order: Order) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        this._$order.next(order);
        if (order && order.cartItems && order.cartItems.length > 0) {
            localStorage.setItem(`order${_site}`, this._urlService.encode(JSON.stringify(order)));
        } else {
            localStorage.removeItem(`order${_site}`);
        }
    }

    submitOrder(order: Order, totalprice) {
        let _site = this.config.getCurrentSite();
        let _site1 = this.config.getCurrentSite();

        let params = '';
        if (this.config.isPartnerPage()) {
            // todo: change to portalId when backend is adjusted
            // _site = 'de_de';

            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    this.portalId = portalId;
                    const temp = portalId.toLocaleUpperCase().split('-').join('_');
                    params = `?portalName=${temp}&countryCode=null`;
                    _site = portalId.toLocaleUpperCase().split('-').join('_');
                    _site1 = portalId;
                }
            });
        } else {
            params = `?countryCode=${_site}&portalName=null`;
        }

        let cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };

        if (localStorage.getItem(`cartItems${_site1}`)) {
            cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site1}`)));
            this._urlService.encode(JSON.stringify(localStorage.setItem('eventsHotels', localStorage.getItem(`cartItems${_site1}`))));
        }
        let orderObj;
        if (this.config.isPartnerPage()) {
            const lang = JSON.parse(sessionStorage.getItem('portalLang'))?.lang;
            orderObj = {
                cartItems: null,
                user: null,
                billingDetails: null,
                participants: [],
                portalName: _site,
                language: lang
            };
        } else {
            orderObj = {
                cartItems: null,
                user: null,
                billingDetails: null,
                participants: [],
                countryCode: _site,
                language: _site.split('_')[0]
            };
        }
        if (order) {
            this.removeHouseNumberInUserObjects(order);
            let billingChanged = false
            if (this.config.isBillingContactEdited === true) {
                billingChanged = true
            } else {
                billingChanged = false
            }
            orderObj.cartItems = cartItems;
            orderObj.user = order.user;
            orderObj.billingDetails = this.removeHouseNumber(order.billing);
            orderObj.billingDetails.changed = billingChanged;
            orderObj.participants = order.participants;
        }

        if (orderObj && orderObj.user && orderObj.user.salutation) {
            orderObj.user.salutation =
                typeof orderObj.user.salutation === 'string' ? orderObj.user.salutation : orderObj.user.salutation.name;
        }
        if (orderObj && orderObj.billingDetails && orderObj.billingDetails.salutation) {
            orderObj.billingDetails.salutation =
                typeof orderObj.billingDetails.salutation === 'string' ? orderObj.billingDetails.salutation : orderObj.billingDetails.salutation.name;
        }
        if (orderObj && orderObj.participants && orderObj.participants.length > 0) {
            orderObj.participants.forEach((object) => {
                if (object.person.salutation) {
                    object.person.salutation =
                    typeof object.person.salutation === 'string' ? object.person.salutation : object.person.salutation.name;
                }
            });
        }
        const _url = `${environment.APIEndpoint}api/v1/booking`;
        return this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(orderObj), null, true, true).then(
            (data) => {
                this._$order.next([]);
                localStorage.removeItem(`order${_site}`);
                localStorage.removeItem(`cartItems${_site}`);
                localStorage.removeItem('showLogin');
                localStorage.removeItem(`itemsNumber${_site}`);
                const _cartItems = {
                    courses: [],
                    events: [],
                    wishlist: []
                };
                localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(_cartItems)));
                this._cartService.clearCart();
                this.cancleOrder();
                if (!!data) {
                    this.getFailingCourseList(order, data);
                    this.getCoursesWithBookingTypes(order, data);
                }
                return true;
            },
            (error) => {
                console.log(error);
                return false;
            }
        );
    }

    removeHouseNumber(obj) {
        if (obj.houseNumber) {
            obj.address = obj.address + ' ' + obj.houseNumber;
        }
        delete obj['houseNumber'];
        return obj;
    }

    removeHouseNumberInUserObjects(order) {
        if (order.user.houseNumber) {
            if (order.user.houseNumber !== null || order.user.houseNumber !== '') {
                order.user.address = order.user.address + ' ' + order.user.houseNumber;
            }
        }
        delete order.user['houseNumber'];

        order.participants.forEach((object) => {
            let timezone = 'unknown';
            try {
                timezone = /.*\s(.+)/.exec(new Date().toLocaleDateString(navigator.language, { timeZoneName: 'short' }))[1];
            } catch (e) {
                timezone = new Date().toTimeString().match(new RegExp('[A-Z](?!.*[(])', 'g')).join('');
            }
            object.person.timeZone = timezone;
        });
    }

    getTotalPrice() {
        this._$order.subscribe((order) => {
            let totalPrice = 0;
            order.courses.forEach((element) => {
                totalPrice += element.price as number;
            });

            return totalPrice * order.participants.length;
        });
    }

    cancleOrder() {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        this._cartService.clearCart();
        // TODO: See why it's not enough this._$order.next([]); to clear the order
        // Some subscription stays open and updateOrder is called
        // Will check it once we use the BE to populate the events within the order

        this._$order.next([]);
        const order = new Order([]);
        order.participants = [];
        const cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };
        order.cartItems = [];
        localStorage.removeItem(`order${_site}`);
        localStorage.removeItem(`cartItems${_site}`);
        localStorage.removeItem('showLogin');
        localStorage.removeItem(`cartItems${_site}`);
        localStorage.removeItem(`itemsNumber${_site}`);

        order.user = null;
        order.billing = null;

        this.updateOrder(order);
        this._$order.next([]);
        localStorage.removeItem(`order${_site}`);
        localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(cartItems)));
        localStorage.removeItem('showLogin');
    }

    public getEmployees() {
        const url = `${env.APIEndpoint}api/v1/user/getemployees`;

        return this._restApiService.requestGET<any>(url, null, false, true).then(
            (employees) => {
                return employees;
            },
            (error) => {
                return error;
            }
        );
    }

    getFailingCourseList(order, data) {
        this.failingCourseList = [];
        order.cartItems.forEach((course) => {
            data.participantBookings.forEach((participant) => {
            if (participant.courses.length > 0) {
                participant.courses.forEach((courseItem) => {
                    if (course.courseId === courseItem.itemId) {
                        if (courseItem.isBooked === false && this.failingCourseList.indexOf(course.courseName) === -1) {
                            this.failingCourseList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                        }
                    }
                });
            }                                
            if (participant.activities.length > 0) {
                participant.activities.forEach((activity) => {
                    if (course.externalId === activity.itemId) {
                        if (activity.isBooked === false && this.failingCourseList.indexOf(course.courseName) === -1) {
                            this.failingCourseList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                        }
                    }
                });
            }
            if (participant.wishlistCourses.length > 0) {
                participant.wishlistCourses.forEach((wishlistCourse) => {
                    if (course.courseId === wishlistCourse.itemId) {
                        if (wishlistCourse.isBooked === false && this.failingCourseList.indexOf(course.courseName) === -1) {
                            this.failingCourseList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                        }
                    }
                });
            }
            });
        });
        localStorage.setItem('failingCourseList', JSON.stringify(this.failingCourseList));
    }

    getCoursesWithBookingTypes(order, data) {  
        this.onlineRequestList = [];
        this.directBookingList = [];
        order.cartItems.forEach((course) => {
            data.participantBookings.forEach((participant) => {
                if (participant.courses.length > 0) {
                    participant.courses.forEach((courseItem) => {
                        if (course.courseId === courseItem.itemId) {
                            if (courseItem.bookingType === "DirectBooking") {
                            this.directBookingList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            } else if (courseItem.bookingType === "OnlineRequest") {
                                this.onlineRequestList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            }
                        }
                    });
                }

                if (participant.activities.length > 0) {
                    participant.activities.forEach((activity) => {
                    if (course.externalId === activity.itemId) {
                        if (activity.bookingType === "DirectBooking") {
                                this.directBookingList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            } else if (activity.bookingType === "OnlineRequest") {              
                                this.onlineRequestList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            }
                        }
                    });
                }

                if (participant.wishlistCourses.length > 0) {
                    participant.wishlistCourses.forEach((wishlistCourse) => {
                    if (course.courseId === wishlistCourse.itemId) {
                        if (wishlistCourse.bookingType === "DirectBooking") {
                                this.directBookingList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            } else if (wishlistCourse.bookingType === "OnlineRequest") {
                                this.onlineRequestList.push({title: course.courseName, participantFirstName: participant.participant.firstName, participantLastName: participant.participant.lastName});
                            }
                        }
                    });
                }
            });
            localStorage.setItem('directBookingList', JSON.stringify(this.directBookingList));
            localStorage.setItem('onlineRequestList', JSON.stringify(this.onlineRequestList));
        });
    }
}
